'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _taggedTemplateLiteralLoose = require('@babel/runtime/helpers/taggedTemplateLiteralLoose');
var React = require('react');
var bumbag = require('bumbag');
var faSpinnerThird = require('@fortawesome/pro-regular-svg-icons/faSpinnerThird');
var reactFontawesome = require('@fortawesome/react-fontawesome');
var Layout_LandingPage = require('./LandingPage.js');
var Layout_MainPage = require('./MainPage.js');
require('@babel/runtime/helpers/assertThisInitialized');
require('@babel/runtime/helpers/inheritsLoose');
require('@babel/runtime/helpers/defineProperty');
require('react-loads');
require('@medipass/assets/images/Tyro/dark.png');
require('@medipass/web-sdk');
require('../WithTitle.js');
require('react-document-title');
require('@babel/runtime/helpers/extends');
require('@fortawesome/pro-regular-svg-icons/faSlidersH');
require('@fortawesome/pro-solid-svg-icons/faChevronLeft');
require('use-media');
require('../router.js');
require('query-string');
require('react-router-dom');
require('./components/Content.js');
require('@babel/runtime/helpers/objectWithoutPropertiesLoose');
require('./components/LoadingPage.js');
require('./components/Header.js');
require('./components/UserMenu.js');
require('@fortawesome/pro-solid-svg-icons/faComments');
require('@fortawesome/pro-solid-svg-icons/faBook');
require('@fortawesome/pro-solid-svg-icons/faSignOutAlt');
require('@fortawesome/pro-solid-svg-icons/faUser');
require('@fortawesome/pro-solid-svg-icons/faCaretDown');
require('@fortawesome/pro-solid-svg-icons/faQuestionCircle');
require('@medipass/utils/intercom');
require('../state.js');
require('constate');
require('../contexts/DataTableContext.js');
require('@fortawesome/pro-solid-svg-icons/faBars');
require('../hooks/useMediaQuery.js');
require('./components/SubHeader.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _taggedTemplateLiteralLoose__default = /*#__PURE__*/_interopDefaultLegacy(_taggedTemplateLiteralLoose);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _templateObject;
var Container = bumbag.styled(bumbag.Box)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose__default["default"](["\n  &&& {\n    align-items: center;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding-top: 40px !important;\n    padding-bottom: 40px !important;\n  }\n"])));

var LoadingPage = function LoadingPage(_ref) {
  var isMain = _ref.isMain;
      _ref.title;
  var WrapperPage = isMain ? Layout_MainPage["default"] : Layout_LandingPage["default"];
  return /*#__PURE__*/React__default["default"].createElement(WrapperPage, {
    minWidthBreakpoint: "mobile",
    title: "Loading..."
  }, /*#__PURE__*/React__default["default"].createElement(Container, null, /*#__PURE__*/React__default["default"].createElement(reactFontawesome.FontAwesomeIcon, {
    icon: faSpinnerThird.faSpinnerThird,
    size: "2x",
    className: "text-primary-base animate-spin"
  }), /*#__PURE__*/React__default["default"].createElement("h2", {
    className: "mb-5 mt-4 text-xl font-bold"
  }, "Loading...")));
};

LoadingPage.defaultProps = {
  isMain: false,
  title: null
};

exports["default"] = LoadingPage;
